import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Stack, Typography } from '@mui/material';

function SummaryCard({ label, value }) {
  return (
    <Paper
      variant="outlined"
      sx={{ flex: 1, p: 1.5, borderRadius: 3, bgcolor: 'background.default' }}
    >
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {label}
      </Typography>
      <Typography variant="h5" sx={{ fontWeight: 500 }}>
        {value}
      </Typography>
    </Paper>
  );
}

SummaryCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
};

export default function ClinicalProductionSummary({ summary }) {
  const {
    totalProducedFormatted,
    proceduresCount,
    totalReceivedFormatted,
    totalToReceiveFormatted,
    receivedPercentage,
  } = summary;

  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      <Stack direction="row" spacing={1}>
        <SummaryCard label="Total produzido" value={totalProducedFormatted} />
        <SummaryCard label="Procedimentos" value={proceduresCount} />
      </Stack>

      <Paper
        variant="outlined"
        sx={{
          p: 1.5,
          borderRadius: 3,
          bgcolor: 'background.default',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Box>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Produzido × recebido
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {totalReceivedFormatted} recebido ·{' '}
            <Box component="span" sx={{ color: 'warning.main' }}>
              {totalToReceiveFormatted} a receber
            </Box>
          </Typography>
        </Box>

        <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
          <Typography variant="h6" sx={{ fontWeight: 500, lineHeight: 1.2 }}>
            {receivedPercentage}%
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            recebido
          </Typography>
        </Box>
      </Paper>
    </Stack>
  );
}

ClinicalProductionSummary.propTypes = {
  summary: PropTypes.shape({
    totalProducedFormatted: PropTypes.string,
    proceduresCount: PropTypes.number,
    totalReceivedFormatted: PropTypes.string,
    totalToReceiveFormatted: PropTypes.string,
    receivedPercentage: PropTypes.number,
  }).isRequired,
};
